import { gql } from '@apollo/client';

export type GetUserInfoVariables = {
  user: string;
  chainId: number;
};

// TODO: I likely don't need all these fields
// NOTE: If ever forking this to another repo make sure to update the host
export const getUserInfoQuery = gql`
  query userInfo($user: String!, $chainId: Int) {
    userInfo(user: $user, chainId: $chainId, legacy: false, host: "app.ichi.org") {
      farms {
        poolId
        pendingIchi
        lpOwnership
        userLP
        rewardLP
        availableLP
        isLegacy
      }
      tokens {
        name
        displayName
        address
        balance
        unclaimed
        decimals
        price
      }
    }
  }
`;
